import React, { useCallback, useEffect, useState } from "react";
import { Box, Flex, HStack, Icon, Tabs, TabList, Tab, TabPanels, TabPanel, Text } from "@chakra-ui/react";
import { HeaderWithStats } from "services/MetadataServices";
import { fetchAnalystList } from "services/serviceUtils";
import WorkflowListContainer from "modules/workflow/containers/WorkflowList";
import WorkflowRuns from "modules/workflow/containers/WorkflowRuns";
import { AppIcons } from "constants/icons";

const WorkflowPage: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const [analystsList, setAnalystsList] = useState<HeaderWithStats[]>([]);
  const [isLoadingAnalysts, setIsLoadingAnalysts] = useState(true);

  const loadAnalysts = useCallback(async () => {
    setIsLoadingAnalysts(true);
    const list = await fetchAnalystList(false);
    setAnalystsList(list);
    setIsLoadingAnalysts(false);
  }, []);

  useEffect(() => {
    loadAnalysts();
  }, [loadAnalysts]);

  return (
    <Box h="100vh" w="100%" bg="white" overflow="hidden">
      <Flex h="100%" w="100%" justify="center">
        <Box w="100%" maxW="1000px" h="100%" px={5} py={6} display="flex" flexDirection="column" minH={0}>
          <Tabs
            mt={6}
            flex={1}
            display="flex"
            flexDirection="column"
            minH={0}
            colorScheme="purple"
            variant="line"
            index={tabIndex}
            onChange={index => setTabIndex(index)}
          >
            <Flex justify="space-between" align="center" mb={6}>
              <TabList border="none" gap={7}>
                <Tab
                  px={0}
                  pb={2}
                  fontSize="xl"
                  fontWeight="600"
                  color="gray.500"
                  _focus={{ bg: "transparent", boxShadow: "none" }}
                  _active={{ bg: "transparent" }}
                  _selected={{
                    color: "purple.700",
                    borderColor: "purple.700",
                    borderBottomWidth: "3px",
                    fontWeight: "700",
                  }}
                  _hover={{ color: "purple.700" }}
                >
                  <HStack spacing={2}>
                    <Icon as={AppIcons.workflow} boxSize={6} />
                    <Text fontSize="xl" fontWeight="600" mb={0}>
                      Workflows
                    </Text>
                  </HStack>
                </Tab>
                <Tab
                  px={0}
                  pb={2}
                  fontSize="xl"
                  fontWeight="600"
                  color="gray.500"
                  _focus={{ bg: "transparent", boxShadow: "none" }}
                  _active={{ bg: "transparent" }}
                  _selected={{
                    color: "purple.700",
                    borderColor: "purple.700",
                    borderBottomWidth: "3px",
                    fontWeight: "700",
                  }}
                  _hover={{ color: "purple.700" }}
                >
                  <HStack spacing={2}>
                    <Icon as={AppIcons.workflowRun} boxSize={6} />
                    <Text fontSize="xl" fontWeight="600" mb={0}>
                      Past Runs
                    </Text>
                  </HStack>
                </Tab>
              </TabList>
            </Flex>

            <TabPanels flex={1} display="flex" flexDirection="column" minH={0}>
              {/* Workflows Tab */}
              <TabPanel px={0} py={0} flex={1} display="flex" flexDirection="column" minH={0}>
                <WorkflowListContainer analystsList={analystsList} isLoadingAnalysts={isLoadingAnalysts} />
              </TabPanel>

              {/* Workflow Runs Tab */}
              <TabPanel px={0} py={0} flex={1} display="flex" flexDirection="column" minH={0}>
                <WorkflowRuns analystsList={analystsList} isTabActive={tabIndex === 1} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </Box>
  );
};

export default WorkflowPage;
